import { getStackFramesFromError } from './getStackFramesFromError';
export function parseStacktrace(error) {
    return {
        frames: getStackFramesFromError(error),
    };
}
